import { render, staticRenderFns } from "./AddImporterDialog.vue?vue&type=template&id=7847f3b5&scoped=true"
import script from "./AddImporterDialog.vue?vue&type=script&lang=js"
export * from "./AddImporterDialog.vue?vue&type=script&lang=js"
import style0 from "./AddImporterDialog.vue?vue&type=style&index=0&id=7847f3b5&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7847f3b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7847f3b5')) {
      api.createRecord('7847f3b5', component.options)
    } else {
      api.reload('7847f3b5', component.options)
    }
    module.hot.accept("./AddImporterDialog.vue?vue&type=template&id=7847f3b5&scoped=true", function () {
      api.rerender('7847f3b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Importer/components/AddImporterDialog.vue"
export default component.exports